// Add your custom JS here.
jQuery(document).ready(function ($) {
  // Check if we are on mobile
  let isMobile = window.matchMedia(
    "only screen and (max-width: 760px)"
  ).matches;

  if (isMobile) {
    // if on mobile
    // Add a click event listener to the first <li>
    $(".navbar-extra-list li:first-child").on("click", function (e) {
      e.preventDefault();
      // Toggle the visibility of the other <li> elements
      $(".navbar-extra-list li:not(:first-child)").toggle();
    });
  }

  if ($("body").hasClass("single-projetos")) {
    // Find the image inside the .ph-full-width-image div
    var $image = $(".ph-full-width-image img");

    // Calculate the bottom position of the image
    var imageBottom = $image.offset().top + $image.outerHeight();

    // Smooth scroll to the bottom of the image
    $("html, body").animate(
      {
        scrollTop: imageBottom - $(window).height(),
      },
      500
    ); // 1000 milliseconds = 1 second for the scroll duration
  }
  // Project list
  if ($("body").hasClass("post-type-archive-projetos")) {
    var $grid = $(".grid-masonry").masonry({
      percentPosition: true,
    });

    // Function for mouseenter/touchstart (show effect)
    function showElements() {
      $(this).find("img").fadeIn();
      $(this).find(".project-data").addClass("position-absolute");
      $(this).find("h3").addClass("text-white");
      $(this).find("p").addClass("text-white");
      $grid.masonry("layout");
    }

    // Function for mouseleave/touchend (hide effect)
    function hideElements() {
      $(this)
        .find("img")
        .fadeOut("slow", function () {
          $grid.masonry("layout");
          $(this)
            .parent()
            .find(".project-data")
            .removeClass("position-absolute");
          $(this).parent().find("h3").removeClass("text-white");
          $(this).parent().find("p").removeClass("text-white");
        });
    }

    // Apply to desktop hover
    $(".other-post").hover(showElements, hideElements);

    // Apply to mobile touch
    $(".other-post").on("touchstart", showElements);
    $(".other-post").on("touchend", hideElements);
  }

  if ($("body").hasClass("page-template-page-studio")) {
    // TEAM MODULE
    // When a team name is clicked
    $(document).on("click", ".team-name-link", function (e) {
      e.preventDefault(); // Prevent default link behavior

      // Remove the "active" class from all team names
      $(".team-name-link").removeClass("active");

      // Add the "active" class to the clicked team name
      $(this).addClass("active");

      // Get the team member's ID from the data-id attribute
      var teamId = $(this).data("id");

      // Hide all team members
      $(".team-member").hide();

      // Show the clicked team member
      $('.team-member[data-id="' + teamId + '"]').show();
    });
  }

  if ($("body").hasClass("home")) {
    // remove the footer
    $("#wrapper-footer").remove();
    
    /*** Get the height of the header, use it to make the layout
    const headerHeight = $("#wrapper-navbar").height();
    const headerHandmargin = headerHeight + 40;
    if (!checkmobile) {
      // Set the height of each .projeto-image
      $(".projeto-image").each(function () {
        $(this).css("height", `calc(100vh - ${headerHandmargin}px)`);
      });
    } else {
      // adjust to mobile layout
      $(".projeto-carousel").css("margin-top", "-" + headerHeight + "px");
    }
    */
    const headerHeight = $("#wrapper-navbar").height();
    const arrowHeight = $(".arrow-down-container").height();

    $(".projeto-carousel").css("margin-top", "-" + headerHeight + "px");

    // Do the carroussel
    $(".projeto-carousel").slick({
      autoplay: true,
      autoplaySpeed: 8000,
      dots: false, // Show dots for navigation
      arrows: true, // Show arrows for navigation
      infinite: true, // Infinite looping
      speed: 500, // Transition speed
      slidesToShow: 1, // Show one slide at a time
      slidesToScroll: 1, // Scroll one slide at a time
      vertical: true, // Enable vertical sliding
      verticalSwiping: true, // Enable vertical swiping (optional)
      nextArrow: $(".ph-next-arrow"),
    });
  } // end if home
});
